import { getOrElse } from 'fp-ts/Option';
import {
  ENGAGEMENT_OVERVIEW,
  CLICKS,
  TOTAL_SENDS,
  OPENS,
  formatOneDecimalPlaceOption,
} from 'modules/intelligentInsights/brandAffinityInsights/constants';
import {
  StyledEngagementCard,
  StyledEngagementOverline,
  StyledOverviewMetrics,
  StyledSubtitle,
  StyledCountDivider,
  StyledMetric,
  StyledMetricRow,
  StyledHeading,
} from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/common.styles';
import { localizeCompactNumber } from 'utils/l10n';
import { useCoreContext } from 'modules/intelligentInsights/brandAffinityInsights/contexts/core/CoreContext';
import {
  defaultCalculatedEngagementMetrics,
  useDataManagementContext,
} from 'modules/intelligentInsights/brandAffinityInsights/contexts/dataManagement/DataManagementContext';

export const EngagementOverviewCard = () => {
  const { selectedAffinityTab } = useCoreContext();
  const { managedInsightsData } = useDataManagementContext();
  const engagementMetrics = getOrElse(() => defaultCalculatedEngagementMetrics)(
    managedInsightsData.engagementMetrics,
  );
  const { overview } = engagementMetrics[selectedAffinityTab];

  return (
    <StyledEngagementCard>
      <StyledEngagementOverline>{ENGAGEMENT_OVERVIEW}</StyledEngagementOverline>
      <StyledOverviewMetrics>
        <StyledMetricRow>
          <StyledMetric>
            <StyledSubtitle>{TOTAL_SENDS}</StyledSubtitle>
          </StyledMetric>
          <StyledHeading>
            {localizeCompactNumber(overview.sends, undefined, formatOneDecimalPlaceOption)}
          </StyledHeading>
        </StyledMetricRow>
        <StyledCountDivider />
        <StyledMetricRow>
          <StyledMetric>
            <StyledSubtitle>{OPENS}</StyledSubtitle>
          </StyledMetric>
          <StyledHeading>
            {localizeCompactNumber(overview.opens, undefined, formatOneDecimalPlaceOption)}
          </StyledHeading>
        </StyledMetricRow>
        <StyledCountDivider />
        <StyledMetricRow>
          <StyledMetric>
            <StyledSubtitle>{CLICKS}</StyledSubtitle>
          </StyledMetric>
          <StyledHeading>
            {localizeCompactNumber(overview.clicks, undefined, formatOneDecimalPlaceOption)}
          </StyledHeading>
        </StyledMetricRow>
      </StyledOverviewMetrics>
    </StyledEngagementCard>
  );
};
